import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  playing: false,
  playedPercent: 0,
  loadedPercent: 0,
  duration: 0,
  playedSeconds: null,
  voiceOnly: false,
  url: null,

  minimizePlayer: false,

  topicData: null,

  minimizePlayerBackUrl: null,

  playAll: false,
  playList: [],

  videoLandscape: false,
  fullscreenFunc: 0,
  playbackRate: 1.0,
};

export const playerSlice = createSlice({
  name: "player",
  initialState,

  reducers: {
    setPlaying: (state, action) => {
      state.playing = action.payload;
    },
    setPlayedPercent: (state, action) => {
      state.playedPercent = action.payload;
    },
    setPlayedSeconds: (state, action) => {
      state.playedSeconds = action.payload;
    },
    setLoadedPercent: (state, action) => {
      state.loadedPercent = action.payload;
    },
    setDuration: (state, action) => {
      state.duration = action.payload;
    },
    setVoiceOnly: (state, action) => {
      state.voiceOnly = action.payload;
    },
    setUrl: (state, action) => {
      state.url = action.payload;
    },

    setMinimizePlayer: (state, action) => {
      state.minimizePlayer = action.payload;
    },

    setTopicData: (state, action) => {
      state.topicData = action.payload;
    },

    setMinimizePlayerBackUrl: (state, action) => {
      state.minimizePlayerBackUrl = action.payload;
    },

    setPlayAll: (state, action) => {
      state.playAll = action.payload;
    },
    setPlayList: (state, action) => {
      state.playList = action.payload;
    },
    setVideoLandscape: (state, action) => {
      state.videoLandscape = action.payload;
    },
    setFullscreenFunc: (state, action) => {
      state.fullscreenFunc = action.payload;
    },
    setPlaybackRate: (state, action) => {
      state.playbackRate = action.payload;
    },
  },
});

export const getPlayerState = (state) => state.player;
export const {
  setPlaying,
  setPlayedPercent,
  setPlayedSeconds,
  setLoadedPercent,
  setDuration,
  setVoiceOnly,
  setUrl,

  setMinimizePlayer,

  setTopicData,

  setMinimizePlayerBackUrl,

  setPlayAll,
  setPlayList,

  setVideoLandscape,
  setFullscreenFunc,
  setPlaybackRate,
} = playerSlice.actions;

export default playerSlice.reducer;
